import { render, staticRenderFns } from "./SsoCard.vue?vue&type=template&id=24294847&"
import script from "./SsoCard.vue?vue&type=script&lang=js&"
export * from "./SsoCard.vue?vue&type=script&lang=js&"
import style0 from "./SsoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports